import $ from 'jquery';

import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import { cadenzaTopWindow } from 'cadenza/utils/iframe';
import { on } from 'cadenza/utils/event-util';

const CADENZA_SESSION_TIMEOUT_EVENT_NAME = 'cadenza-session-timeout';
const SESSION_POLLING_URL = '/pages/poll/poll.xhtml';
const CADENZA_LOGIN_LOGOUT_PAGE = '/pages/access/login.xhtml';
const INVALID_SESSION_REDIRECT_URL = `${CADENZA_LOGIN_LOGOUT_PAGE}?loginStatus=invalidSession`;

export function setupSessionPoller (cadenzaSessionPollingInterval) {
  if (window === cadenzaTopWindow) {
    // Add listener on window to handle session timeouts occuring in the ajax-function in the future
    on(window, CADENZA_SESSION_TIMEOUT_EVENT_NAME, handleCadenzaSessionTimeOut);

    // Add session polling to the cadenzaTopWindow (and only there for the moment), if the current
    // page opened in the browser is not the login page
    const loginLogoutPageCurrentlyOpened = location.href.includes(cadenzaUrl(CADENZA_LOGIN_LOGOUT_PAGE));
    if (!loginLogoutPageCurrentlyOpened && cadenzaSessionPollingInterval) {
      setInterval(() => {
        $.ajax(cadenzaUrl(SESSION_POLLING_URL))
          .fail(handleCadenzaSessionTimeOut);
      }, cadenzaSessionPollingInterval);
    }
  }
}

function handleCadenzaSessionTimeOut () {
  window.Disy.hasActiveSession = false;
  location.href = cadenzaUrl(INVALID_SESSION_REDIRECT_URL);
}
